import {v4 as uuidv4} from 'uuid';

export default () => ({
    _id: 'reservee_' + uuidv4(),
    full_name: '',
    dob: '',
    gender: null,
    height: null,
    weight: '',
    shoe_size: null,
    package_id: null,
    package_price: null,
    skier_type: null,
    ski_board_length: '',
    snowboard_type: 'regular',
    addons: []
});
